import React from "react";
import useWindowDimensions from "../hooks/useWindowDimensions";
import useTheme from "../hooks/useTheme";

export default function Authentication(props: {
  authentication: string[];
  style?: React.CSSProperties;
}) {
  const { isSmallLayout, isMediumLayout } = useWindowDimensions();
  const theme = useTheme();
  const authTypes = props.authentication ?? ["Standard"];

  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        paddingTop: isSmallLayout || isMediumLayout ? 5 : 0,
        paddingBottom: isSmallLayout || isMediumLayout ? 2 : 0,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        ...props.style,
      }}
    >
      {(isSmallLayout || isMediumLayout) && (
        <h4
          style={{
            color: theme.textColor,
            fontWeight: "normal",
          }}
        >
          {"Authentication:"}
        </h4>
      )}
      {authTypes.map((auth) => (
        <h4
          key={auth}
          style={{
            color: theme.textColor,
            fontWeight: "normal",
          }}
        >
          {auth}
        </h4>
      ))}
    </div>
  );
}
